import React from 'react';
import ReactDOM from 'react-dom';
// import './index.css';
// import './scss/style.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import store from './stores'
import { RegionWrapper } from '@operations/shared';
import { Region } from '../../shared/src/utils/commonInterfaces';
import axiosInstance from './stores/requests';
import { registerRequestByRegion } from '../../shared/src/utils/getExportAxiosRequestByRegion';

registerRequestByRegion(Region.SE, (api, info) => axiosInstance(api as string, info));

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <RegionWrapper region={Region.SE}>
        <App />
      </RegionWrapper>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
